export class UrlHelper {

  /**
   * Remove leading slashes.
   *
   * @param url An URL
   * @return The URL without leading slashes
   */
  public static removeLeadingSlashes(url: string): string {
    return url.replace(/^\/+/g, "");
  }

  /**
   * Remove trailing slashes.
   *
   * @param url An URL
   * @return The URL without trailing slashes
   */
  public static removeTrailingSlashes(url: string): string {
    return url.replace(/\/+$/g, "");
  }
}
